<template>
  <div class="container-custom">
    <!-- Breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Products',
          to: {
            name: 'Products'
          }
        },
        {
          name: 'Create',
          to: {
            name: 'ProductCreate'
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增產品資訊</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!--  -->
    <ProductInfoEditCreate></ProductInfoEditCreate>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ProductInfoEditCreate from '@/views/C-3__Products/c/ProductInfoEditCreate.vue';

export default {
  components: {
    Breadscrumbs,
    ProductInfoEditCreate,
  },
  created() {
    this.setProduct({
      id: null,
      name: null,
      model_name: null,
      model_name_sap: null,
      first_headline: null,
      second_headline: null,
      bu_id: this.currentBuTabId,
      product_category_id: null,
      product_sub_category_id: null,
      order: null,
      main_status: 1,
      status: 1,
      description: null,
      is_landing_page: 0,
      landing_page_url: null,
      remark: null,
      seo_title: null,
      seo_description: null,
      seo_keyword: null,
      seo_url: null,
      main: [],
      ksp: [],
      compatible: [],
      colors: [],
      descriptions: [],
      specs: [],
      effect_url: null,
      mirror_flip: 0
    });
  },
  computed: {
    ...mapState(['currentBuTabId']),
    ...mapState('product', ['product']),
  },
  methods: {
    ...mapActions('product', {
      setProduct: 'setProduct',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.$router.push({ name: 'Products' });
    },
    saveHandler() {
      this.save(this.product).then(() => {
        this.$router.push({ name: 'Products' });
        this.clear();
      });
    },
  },
};
</script>

<style></style>
